import { Upload } from 'antd';
import { InboxOutlined } from '@ant-design/icons';
import { useUploadDocument } from 'api/documents/use-upload-document';
import { UserRole, useRoleGuard } from 'shared/hooks/use-role-guard.ts';
import type { IDocumentsUploadProps } from './types';

export const DocumentsUpload = (props: IDocumentsUploadProps) => {
  const { clientId, orderId, cargoId, tripId, invoiceId, whTaskId, expenseId } = props;

  const isAllow = useRoleGuard([
    UserRole.admin,
    UserRole.assistant,
    UserRole.accountant,
    UserRole.customer_manager,
    UserRole.transport_manager,
    UserRole.storekeeper,
  ]);

  const { mutateAsync: uploadDocument } = useUploadDocument();

  const customRequest = async (options: any) => {
    const formData = new FormData();

    formData.append('file', options.file);
    if (tripId) {
      formData.append('tripId', String(tripId));
    } else if (cargoId) {
      formData.append('cargoId', String(cargoId));
    } else if (orderId) {
      formData.append('orderId', String(orderId));
    } else if (clientId) {
      formData.append('clientId', String(clientId));
    } else if (invoiceId) {
      formData.append('invoiceId', String(invoiceId));
    } else if (whTaskId) {
      formData.append('warehouseTaskId', String(whTaskId));
    } else if (expenseId) {
      formData.append('expenseId', String(expenseId));
    }

    await uploadDocument({
      data: formData,
      onUploadProgress: options.onProgress,
      onSuccess: options.onSuccess,
    });
  };

  if (!isAllow) return null;

  return (
    <Upload.Dragger name='files' customRequest={customRequest} showUploadList={false} multiple>
      <p className='ant-upload-drag-icon'>
        <InboxOutlined />
      </p>
      <p className='ant-upload-text'>Click or drag file to this area to upload</p>
    </Upload.Dragger>
  );
};
